import { actionTypes } from "../actions/action_types";

const initialState = {
  master_cluster: [],
  master_area: [],
  cluster: [],
  area: [],
  branch: [],
  coveredDate: [],
  pepp_hierarchy: [],
};

export default function crdm_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.CRDM_GET_CLUSTERS:
      stateCopy.cluster = action.payload;
      return stateCopy;

    case actionTypes.CRDM_GET_AREAS:
      stateCopy.area = action.payload;
      return stateCopy;

    case actionTypes.CRDM_GET_MASTER_CLUSTERS:
      stateCopy.master_cluster = action.payload;
      return stateCopy;

    case actionTypes.CRDM_GET_MASTER_AREAS:
      stateCopy.master_area = action.payload;
      return stateCopy;

    case actionTypes.CRDM_GET_PEPP_HIERARCHY:
      stateCopy.pepp_hierarchy = action.payload;
      return stateCopy;

    case actionTypes.CRDM_GET_PEPP_BRANCH:
      stateCopy.branch = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
